export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function toRelativeTime(timestamp: number): string {
  const diff = timestamp - Date.now(); // negative when in the past
  const formatter = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  const absMs = Math.abs(diff);
  const minuteMs = 60 * 1000;
  const hourMs = 60 * minuteMs;
  const dayMs = 24 * hourMs;

  if (absMs < minuteMs) {
    return formatter.format(Math.round(diff / 1000), 'second');
  }
  if (absMs < hourMs) {
    return formatter.format(Math.round(diff / minuteMs), 'minute');
  }
  if (absMs < dayMs) {
    return formatter.format(Math.round(diff / hourMs), 'hour');
  }
  return formatter.format(Math.round(diff / dayMs), 'day');
}
